import { Injectable } from '@angular/core';
import { UserProfileService } from 'sigv-library';
import { REPLACE_WORDS } from '../constants/word-replace.constant';
import { UserRoleService } from './user-role.service';

@Injectable({
  providedIn: 'root'
})
export class ReplaceWordService {

  constructor(
    private userRoleService: UserRoleService,
    private userProfile: UserProfileService
  ) { }

  isNeedReplace(): boolean {

    if(!this.userProfile.currentUserValue?.userNo) {
      return false;
    }

    return this.userRoleService.acknowledgeUsers.includes(this.userProfile.currentUserValue?.userNo);
  }

  Replace(value: string | undefined, user: string | undefined = ''): string {
    if (!value || typeof value !== 'string') {
          return '';
        }

        user = user || this.userProfile.currentUserValue?.userNo;

        if (!user || !this.userRoleService.acknowledgeUsers.includes(user)) {
          return value;
        }

        const replaceWords: { [key: string]: string } = REPLACE_WORDS;

        // 確保 matchWordsReplace 存在於正確的 service
        return this.userRoleService.matchWordsReplace(value, replaceWords)
  }
}
